import { Checkbox, Flex, InputErrorMessage } from '@lokalise/louis';
import { useState } from 'react';
import type { ChangeEvent } from 'react';

import { Input2 } from '../components';

interface PasswordInputProps {
    value: string | undefined;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    passwordType?: 'new-password' | 'current-password';
    id?: string;
    name?: string;
    error?: string;
}

const PasswordInput = ({ value, onChange, placeholder, passwordType, id, name, error }: PasswordInputProps) => {
    const [shouldShowPassword, setShowPassword] = useState(false);

    return (
        <Flex gap={2}>
            <Input2
                id={id}
                name={name}
                type={shouldShowPassword ? 'text' : 'password'}
                autoComplete={passwordType}
                placeholder={placeholder || 'Password'}
                value={value}
                onChange={onChange}
            />
            {error !== undefined && <InputErrorMessage id="password">{error}</InputErrorMessage>}
            <Checkbox
                checked={shouldShowPassword}
                onChange={(e) => setShowPassword(e.target.checked)}
                aria-label={
                    shouldShowPassword
                        ? 'Hide password'
                        : "Show password. Warning, you're password will be visible on the screen."
                }
            >
                Show password
            </Checkbox>
        </Flex>
    );
};

export default PasswordInput;
